import { useFormContext } from 'react-hook-form';
import { Text } from '@consumidor-positivo/aurora';
import { InfoBox } from '../../../components/InfoBox';
import { SelectOptions } from '../../../components/SelectOptions';

import '../styles.scss';

export const AnnuityStep = () => {
  const { setValue } = useFormContext();

  const options = [
    { id: true, label: 'Sim' },
    { id: false, label: 'Não' },
  ];

  return (
    <div className="mm-form__step">
      <div className=" mm-form__step--annuity">
        <Text as="h2" variant="heading-small" variantDesk="heading-medium" weight="bold">
          O cartão pode ter anuidade?
        </Text>
        <SelectOptions htmlType="submit" options={options} onSelect={(option) => setValue('annuity', option.id)} />
        <InfoBox stepSlug="annuity" />
      </div>
    </div>
  );
};
